module.exports = __webpack_public_path__ + "static/media/update.0c1badac.svg";